export default __webpack_public_path__ + "static/media/avatar-5.fc3190f3.jpg";